import { HeadcountInsightsQuery } from 'generated/resources/graphql'
import { sum } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { GroupByType } from 'modules/performance_analytics/components/helpers'

import { GroupByData } from './types'

export const extractGroupByData = (
  data: HeadcountInsightsQuery | undefined,
  groupBy: GroupByType | null | undefined
): GroupByData & { totalCount: number } => {
  if (!groupBy) {
    const totalCount =
      data?.performance?.employeePerformanceInsightsSummariesConnection?.totalCount ?? 0
    return { counts: [totalCount], values: [i18n.t('common.total')], totalCount }
  }

  if (!data?.performance?.employeePerformanceInsightsSummariesConnection?.aggregate?.terms) {
    return { counts: [], values: [], totalCount: 0 }
  }

  const terms = data.performance.employeePerformanceInsightsSummariesConnection.aggregate.terms

  switch (groupBy) {
    case 'legal_entity': {
      const counts = terms.legalEntityId?.count ?? []
      const values = terms.legalEntityId?.values ?? []
      return {
        counts,
        values,
        totalCount: sum(counts),
      }
    }
    case 'manager': {
      const counts = terms.managerId?.count ?? []
      const values = terms.managerId?.values ?? []
      return {
        counts,
        values,
        totalCount: sum(counts),
      }
    }
    case 'team': {
      const counts = terms.teamId?.count ?? []
      const values = terms.teamId?.values ?? []
      return {
        counts,
        values,
        totalCount: sum(counts),
      }
    }
    case 'nationality': {
      const counts = terms.nationality?.count ?? []
      const values = terms.nationality?.values ?? []
      return {
        counts,
        values,
        totalCount: sum(counts),
      }
    }
    case 'workspace': {
      const counts = terms.workspace?.count ?? []
      const values = terms.workspace?.values ?? []
      return {
        counts,
        values,
        totalCount: sum(counts),
      }
    }
    case 'gender': {
      const counts = terms.gender?.count ?? []
      const values = terms.gender?.values ?? []
      return {
        counts,
        values,
        totalCount: sum(counts),
      }
    }
    default:
      return { counts: [], values: [], totalCount: 0 }
  }
}
